import {UseCase} from '@s-ui/domain'

export class GetPublishAdTrackingUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   */
  constructor({config, fromDraftJsonToDraftTrackingJsonMapper}) {
    super({config})
    this._fromDraftJsonToDraftTrackingJsonMapper = fromDraftJsonToDraftTrackingJsonMapper
  }

  execute({draft}) {
    return Promise.resolve(this._fromDraftJsonToDraftTrackingJsonMapper.map({draft}))
  }
}
